module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento16.e5bb2748.svg";